@if (pending) {
    <ui-pre-loader />
} @else {
    @if (displayEntities.data.length > 0) {
        <div class="table__container">
            <table class="table w-100" mat-table matSort [trackBy]="identity" [dataSource]="displayEntities">
                <ng-container matColumnDef="number">
                    <th class="th--55 text-end" mat-header-cell *matHeaderCellDef>#</th>
                    <td class="text-end text-muted font-size-sm" mat-cell *matCellDef="let item; let i = index">
                        {{ i + 1 + this.displayEntities?.paginator?.pageIndex * this.displayEntities?.paginator?.pageSize }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="prgName">
                    <th class="th--name" mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.program' | translate }}
                    </th>
                    <td class="td--multiline" mat-cell *matCellDef="let item">
                        {{ item.prgName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="trfName">
                    <th class="th--name" mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.ticket' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">
                        @if (item.prgType !== b2bProgramType.NumberOfTrips) {
                            {{ item.trfName }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="prgType">
                    <th class="th--name" mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.forms.labels.prgType' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">{{ 'b2b.data.programType.' + item.prgType | translate }}</td>
                </ng-container>

                <ng-container matColumnDef="orgName">
                    <th class="th--name" mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.partner' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.orgName }}</td>
                </ng-container>

                <ng-container matColumnDef="icons">
                    <th class="th--300" mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <div class="d-flex align-items-center justify-content-end" (click)="stopPropagation($event)">
                            @if (!readonly) {
                                <ui-icon-bs [pseudo]="'gray'" [type]="bsIconTypes.Trash3" (handlerClick)="removeClick.emit(item)" />
                            }
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" uiRowLink (rowActivate)="clickRow.emit(row.prgId)"></tr>
            </table>
        </div>
    } @else {
        <ui-no-matches />
    }
}
<paginator [source]="displayEntities" />
